import { Container } from 'components/box';
import { useIsLoggedIn, useCustomer } from 'hooks/customer';
import dynamic from 'next/dynamic';
import { ClientOnly } from 'components/_shared/widgets/render-control';
import { setGTMPageName } from '../util/tag-manager';
import { PageNamesEnum } from 'types/third-party/gtm';
import CustomerAuthorization from 'components/customer/customer-authorization';

setGTMPageName(PageNamesEnum.myAccount);

const MyAccount = dynamic(() => import('components/my-account'));

const Account = () => {
  const isLoggedIn = useIsLoggedIn();
  const customer = useCustomer();

  return (
    <Container>
      {isLoggedIn && !!customer ? (
        <MyAccount customer={customer} />
      ) : (
        <ClientOnly>
          <CustomerAuthorization headerText="Log in to view your account" />
        </ClientOnly>
      )}
    </Container>
  );
};

export default Account;
